import { AppContext } from '@lightspeed-invoicing/core-client/frontend/index';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import DocumentUploaderDropZone from "../../../../common/document-uploader/dropzone.component.jsx";
import CustomFieldsSelectComponent from '../../../../scheduling-page/CustomFieldsSelectComponent';
import { CUSTOM_FIELD_TYPE, getCustomFieldAvailableFromOptionsByProposalType } from "../../../../utils/customField";

class FileGalleryContentInput extends Component {

    constructor(props, context) {
        super(props, context)
        const content = this.props.value || {}
        this.state = {
            className: this.props.className || '',
            onChange: this.props.onChange || function () { },
            files: content.files || [],
            fileIds:  this.props.fileIds || content.fileIds || [],
            customFieldDefinitionIds: content.customFieldDefinitionIds || [],
            variables: this.props.variables || {},
            hideLabels: this.props.hideLabels || false,
            fileTypes: this.props.fileTypes || '',
        }

        this.handleFileChange = this.handleFileChange.bind(this)
        this.child = React.createRef();
    }

    triggerChanged() {
        this.state.onChange({
            fileIds: this.state.fileIds,
            customFieldDefinitionIds: this.state.customFieldDefinitionIds,
        })
    }

    componentDidMount() {
        if (this.props.files) {
            this.setState({
                files: this.props.files,
            }, () => { this.child.current.updateUploadedDocumentsFromDocuments(this.state.files) })
        } else if (this.props.fileIds && this.props.fileIds.length > 0) {
            Promise.all(this.props.fileIds.map(fileId => AppContext.getApiClient().get('/files/' + fileId)))
                .then((files) => {
                    this.setState({
                        files,
                    }, () => { this.child.current.updateUploadedDocumentsFromDocuments(this.state.files) })
                })
        }
    }

    componentWillReceiveProps(nextProps) {
        const content = nextProps.value || {}
        this.setState({
            files: content.files || this.props.files || [],
            fileIds: content.fileIds || this.props.fileIds || [],
        })
    }

    handleFileChange(files) {
        if (files.length > 0) {
            this.setState({
                files: files,
                fileIds: files.map(i => i.id),
            }, this.triggerChanged)
        } else {
            this.setState({
                files: [],
                fileIds: [],
            }, this.triggerChanged)
        }
    }

    render() {
        return (
            <div>
                <div className="form-group row">
                    {!this.state.hideLabels &&
                        <label className="col-2 col-form-label text-align-right" htmlFor="title">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.file_gallery.files_label"
                                defaultMessage="Files"
                            />
                        </label>
                    }
                    <div className={!this.state.hideLabels ? 'col-10' : 'col-12'} >
                        <DocumentUploaderDropZone
                            accountId={this.props.accountId}
                            ref={this.child}
                            onUpdateDocumentList={this.handleFileChange}
                            maxFiles={10}
                            documents={this.state.files}
                            fileTypes={this.state.fileTypes}
                        />
                        {!this.state.hideLabels && 
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.file_gallery.files_description"
                                    defaultMessage="Files that will be available in the gallery"
                                />
                            </small>
                        }
                    </div>
                </div>
                {!this.state.hideLabels &&
                    <div className="form-group row">
                        <label className="col-2 col-form-label text-align-right" htmlFor="title">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.file_gallery.custom_fields_label"
                                defaultMessage="Custom fields (optional)"
                            />
                        </label>
                        <div className="col-10">
                            <CustomFieldsSelectComponent
                                editable={true}
                                name={'file-gallery-custom-fields'}
                                selectedCustomFieldIds={this.state.customFieldDefinitionIds}
                                onSelectChange={(selectedOptions) => {
                                    this.setState(
                                        { customFieldDefinitionIds: selectedOptions.map(o => o.value) },
                                        this.triggerChanged
                                    )
                                }}
                                isAvailableFrom={getCustomFieldAvailableFromOptionsByProposalType(this.state.variables?.proposalType)}
                                supportedFieldTypes={[CUSTOM_FIELD_TYPE.IMAGE, CUSTOM_FIELD_TYPE.FILE]}
                                placeholder={<FormattedMessage
                                    id="templates.sections.form.edit.content.file_gallery.custom_fields_placeholder"
                                    defaultMessage="Choose one or more custom fields"
                                />}
                            />
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.file_gallery.custom_fields_description"
                                    defaultMessage="Include files that are linked to the chosen custom fields"
                                />
                            </small>
                        </div>
                    </div>  
                }
            </div>
        );
    }
}

export default injectIntl(FileGalleryContentInput)


// WEBPACK FOOTER //
// ./src/template/sections/content/file-gallery/input.component.jsx